import { useEffect } from 'react';

// react-router-dom
import { BrowserRouter as Router } from 'react-router-dom';

// theme
import theme from 'themes';

// providers
import { StylesProvider } from 'providers/StylesProvider';

// components
import CssBaseline from '@material-ui/core/CssBaseline';
import Routes from 'Routes';
import GradientSVG from 'components/shared/GradientSVG';
import GlowSVG from 'components/shared/GlowSVG';
import TextGlowSVG from 'components/shared/TextGlowSVG';
import LineGlowSVG from 'components/shared/LineGlowSVG';


/**
 * @component ThemedApp
 * @summary this is the main application wrapper all pages will render withing
 * this component the main reason is to seprate theme from app and also use provider hooks within this component
 */


function ThemedApp() {

  return (
      <StylesProvider>
        <div>
        {/* <GradientSVG idCSS="progressbar-gradient" firstColor="#FF5F1F" secondColor="#FF5F1F" />
        <GlowSVG idCSS="progressbar-glow" glowColor="#FF5F1F"/> */}

        <GradientSVG idCSS="progressbar-gradient" firstColor="#00ff00" secondColor="#00ff00" />
        <GlowSVG idCSS="progressbar-glow" glowColor="rgb(0,100,0)"/>
        <LineGlowSVG idCSS="progressbar-lineglow" glowColor="#00ff00"/>
        {/* <TextGlowSVG idCSS="progressbar-textglow" glowColor="#00aa00" /> */}

        {/* <GradientSVG idCSS="progressbar-gradient" firstColor="#0000ff" secondColor="#0000ff" />
        <GlowSVG idCSS="progressbar-glow" glowColor="#0000ff"/> */}

        {/* <GradientSVG idCSS="progressbar-gradient" firstColor="#00FFFF" secondColor="#00FFFF" />
        <GlowSVG idCSS="progressbar-glow" glowColor="#00FFFF"/> */}

        {/* <GradientSVG idCSS="progressbar-gradient" firstColor="#cc0000" secondColor="#cc0000" />
        <GlowSVG idCSS="progressbar-glow" glowColor="#ff0000"/> */}


        
        {/* <div dir="rtl"> */}
          {/* <SnackbarProvider
            autoHideDuration={5000}
            maxSnack={1}
            style={{ fontFamily: 'Shabnam, Poppins, sans-serif', direction: 'rtl' }}
          > */}
              <CssBaseline />
              {/* base application */}
              <Router>
                <Routes />
              </Router>
              <div id="portal"></div>
              {/* end base application */}
          {/* </SnackbarProvider> */}
        </div>
      </StylesProvider>
  );
}

export default ThemedApp;
